import React from 'react';

const FieldIdentifierContext = React.createContext<undefined | string>(undefined);

export function FieldIdentifierProvider(props: {
    children: React.ReactNode;
    value: string;
}): React.ReactElement {
    return (
        <FieldIdentifierContext.Provider value={props.value}>
            {props.children}
        </FieldIdentifierContext.Provider>
    );
}

export function useFieldIdentifier(): undefined | string {
    const value = React.useContext(FieldIdentifierContext);
    return value;
}
